var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.72c.351 0 .64.288.64.64 0 .352-.289.64-.64.64H4.08a.642.642 0 01-.64-.64c0-.352.287-.64.64-.64zM14.6 1A2.397 2.397 0 0117 3.4v8.64a2.397 2.397 0 01-2.4 2.4H3.4a2.397 2.397 0 01-2.4-2.4V3.4A2.397 2.397 0 013.4 1zm0 1.28H3.4c-.615 0-1.12.505-1.12 1.12v8.64c0 .615.505 1.12 1.12 1.12h11.2c.615 0 1.12-.503 1.12-1.12V3.4c0-.615-.503-1.12-1.12-1.12zm-.46 3.358a.668.668 0 010 .942l-3.662 3.672a.676.676 0 01-.951.01l-2.37-2.383-2.327 2.665a.663.663 0 01-.5.234.618.618 0 01-.434-.167.67.67 0 01-.067-.942l2.795-3.206a.635.635 0 01.484-.225.665.665 0 01.491.192l2.412 2.406 3.186-3.198a.67.67 0 01.942 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
export default SvgDataOverview;